import { MenuItem, Button } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import { useField } from "formik";
import { v4 as uuid } from "uuid";
import { CustomFormikComponentProps } from "../form/CustomFormikComponents";

type Props = CustomFormikComponentProps & {
    choices: Array<string>;
};

export default function UserInputChoice({ name, setFieldValue, choices }: Props) {
    const [field] = useField(name);
    return (
        <ChoiceSelect
            itemPredicate={filterChoice}
            itemRenderer={renderChoice}
            items={choices}
            onItemSelect={c => {
                setFieldValue(name, c);
            }}
            noResults={<MenuItem disabled={true} text="No results." />}
            popoverProps={{ minimal: true, popoverClassName: "custom-select" }}
        >
            <Button text={field.value !== "" ? field.value : "Select"} rightIcon="caret-down" />
        </ChoiceSelect>
    );
}

const ChoiceSelect = Select.ofType<string>();

const filterChoice: ItemPredicate<string> = (query, choice) => {
    return choice.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};
const renderChoice: ItemRenderer<string> = (choice, { handleClick, modifiers }) => {
    if (!modifiers.matchesPredicate) {
        return null;
    }
    return <MenuItem active={modifiers.active} key={`choice_${uuid()}`} onClick={handleClick} text={choice} />;
};
